import React from "react";
import { useFeedbackStore } from "../../stores/feedbackStore";
import { ProblemInput, SolutionInput } from "./Inputs";
import { FeedbackModalProps, ModalDialog } from "./ModalDialog";
import { Selector, SelectorItem } from "./Selector";

const featurePriorityList: Array<SelectorItem<number>> = [
    {
        display: "Nice to Have",
        value: 100,
    },
    {
        display: "Important",
        value: 200,
    },
    {
        display: "Critical",
        value: 300,
    },
];

export const FeatureModal = ({ error, ...rest }: Omit<FeedbackModalProps, "title">) => {
    const setPriority = useFeedbackStore((state) => state.setPriority);
    return (
        <ModalDialog title="Product Feedback" {...rest}>
            <Selector
                title="Importance"
                defaultValue={100}
                list={featurePriorityList}
                onSetValue={(value) => setPriority(value)}
            />
            <ProblemInput error={error} />
            <SolutionInput />
        </ModalDialog>
    );
};
